// extracted by mini-css-extract-plugin
module.exports = {"linkRequest":"style_linkRequest__gZXVn","sendMailSelectedItems":"style_sendMailSelectedItems__1qgcT","checkboxAll":"style_checkboxAll__1XeEb","checked":"style_checked__3NfGt"};